import React, { useRef } from "react";


import Intro from "./components/Intro/Intro";
import ImageSplit from "./components/ImageSplit/ImageSplit";
import IntroDescriptionOne from "./components/IntroDescriptionOne/IntroDescriptionOne";
import IntroDescriptionTwo from "./components/IntroDescriptionTwo/IntroDescriptionTwo";

import { FaPhone, FaLink } from "react-icons/fa"

import './IntroPage.css'


const Imprint = function (props) {

    const descriptionRef = useRef();


    return (

        <React.Fragment>







            <div className="page-body page-body-first-element" >
                <div className="page-content">
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Wo findest du uns?</span></h2>
                            <p>
                                Combat Sports Lübeck e.V.
                            </p>
                            <p>
                                Hinter den Kirchkaten 43
                            </p>
                            <p>
                                23560 Lübeck
                            </p>
                            <p>
                                <a class="underline cs-text-link" target="_blank" href="https://maps.app.goo.gl/GTde14t5DrZmk7Ca8"><FaLink className="icon-link-text " />Google Maps Link</a>
                            </p>
                        </div>
                    </div>
                    <br></br>
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Kontaktinformationen und Geschäftsstelle</span></h2>
                            <h3>
                                Bitte verwende ausschließlich die Adresse der Geschäftsstelle für Kommunikation über den Postweg.
                            </h3>
                            <br></br>
                            <p>
                                Combat Sports Lübeck e.V.
                            </p>
                            <p>
                                Dornierstraße 4a
                            </p>
                            <p>
                                23568 Lübeck
                            </p>
                            <p>
                                <a class="underline cs-text-link" href="tel:+491703238739"><FaPhone className="icon-link-text " /> : +49 170 323 87 39</a>
                            </p>
                        </div>
                    </div>
                    <br></br>
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Probetraining</span></h2>
                            <p>
                                Wir freuen uns, dass du Interesse an einem Probetraining in unserem Fitnessstudio hast!
                                Wir verstehen, dass du sicherstellen möchtest, dass deine Ziele in guten Händen sind.
                                Bei uns ist das garantiert, denn wir bieten nur betreute Probetrainings an, damit du das Beste aus deinem Besuch herausholen kannst.
                            </p>
                            <h3>
                                Vereinbarung für dein Probetraining:
                            </h3>
                            <p>
                                Um dein Probetraining zu planen, bitten wir dich, uns im Voraus zu kontaktieren.
                                Unsere erfahrenen Trainer stehen bereit, um nicht nur deine Fitnessziele zu besprechen und sicherzustellen, dass du eine effektive und auf dich zugeschnittene Trainingserfahrung erhältst, sondern gegebenenfalls auch,
                                um die Kursauslastung im Muay Thai zu berücksichtigen und sicherzustellen, dass du sicher und verantwortungsvoll mit dem Equipment umgehst.
                            </p>
                            <p>
                                Wir freuen uns dich schon bald bei uns begrüßen zu dürfen!
                            </p>
                        </div>




                    </div>
                </div>

            </div>







            {/* <div className="page-body">
                <div className="page-content">
                    <div className="promo" >
                        <div className="image-wrapper"><img src="https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ" /></div>
                        <h2 className="title" data-cta="Get out there TEST TEST→">Nightlife</h2>
                    </div>
                </div >
            </div > */}


            {/* <div className="page-body">
                <div className="page-content">

                    <IntroDescriptionTwo />

                </div>

            </div> */}








        </React.Fragment >
    )
}

export default Imprint